import { Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import SuspenseLoader from '../components/SuspenseLoader';
import Layout from '../layout';
import { AuthProvider, ProtectRoute } from '../layout/account/auth';
const Loader = (Component) => (props) =>
(
  <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
  const Main = Loader(lazy(()=>import('../screens/main')))
  const Login = Loader(lazy(()=>import('../screens/login')))
  const Register = Loader(lazy(()=>import('../screens/register')))
  const Profile = Loader(lazy(()=>import('../screens/profile')))
  const OneUser = Loader(lazy(()=>import('../screens/oneUser')))
  const Users = Loader(lazy(()=>import('../screens/users')))
  const Events = Loader(lazy(()=>import('../screens/events')))
  const Stuffs = Loader(lazy(()=>import('../screens/stuffs')))
  const Categories = Loader(lazy(()=>import('../screens/categories')))
  const Status = Loader(lazy(()=>import('../screens/status')))
  const Calendar = Loader(lazy(()=>import('../screens/calendar')))
  const Statistics = Loader(lazy(()=>import('../screens/statistics')))
  const NotActivated = Loader(lazy(()=>import('../screens/not-activated')))
  const Awards = Loader(lazy(()=>import('../screens/awards')))
  const Support = Loader(lazy(()=>import('../screens/support')))
  const Gallery = Loader(lazy(()=>import('../screens/gallery')))
   

const router = [
  {
    path: '',
    // element: (
    //   <>
    //   <Layout>
    //     <Main/>
    //   </Layout>
    //   </>
    // ),
    children: [
      {
        path: '/',
        element: <Navigate to="main" replace />
      },
      {
        path: 'main',
        element: (
          // <ProtectRoute>

          <AuthProvider>
                <Layout>
                  <Main/>
                </Layout>
           </AuthProvider>
          // </ProtectRoute>

        )
      },
      {
        path: '/login',
        element: <Login/>
      },
      {
        path: '/register',
        element: <Register/>
      },
      {
        path: '/profile',
        element: (
          <AuthProvider>
          <Layout>
            <Profile />
          </Layout>
          </AuthProvider>
        )
      },
      {
        path: '/user/:id',
        element: (
          <AuthProvider>

          <Layout>
            <OneUser/>
          </Layout>
          </AuthProvider>
        )
      },
      {
        path: '/users',
        element: (
          <AuthProvider>
          <Layout>
            <Users />
          </Layout>

          </AuthProvider>
        )
      },
      {
        path: '/gallery',
        element: (
          <AuthProvider>
          <Layout>
            <Gallery />
          </Layout>

          </AuthProvider>
        )
      },
      {
        path: '/events',
        element: (
          <AuthProvider>

          <Layout>
            <Events />
          </Layout>
          </AuthProvider>
        )
      },
      {
        path: '/stuffs',
        element: (
          <AuthProvider>

          <Layout>
            <Stuffs />
          </Layout>
          </AuthProvider>
        )
      },
      {
        path: '/categories',
        element: (
          <AuthProvider>
          <Layout>
            <Categories />
          </Layout>
          </AuthProvider>
        )
      },
      {
        path: '/status',
        element: (
          <AuthProvider>
          <Layout>
            <Status />
          </Layout>
          </AuthProvider>
        )
      },
      {
        path: '/awards',
        element: (
          <AuthProvider>
          <Layout>
            <Awards />
          </Layout>
          </AuthProvider>
        )
      },
      {
        path: '/support',
        element: (
          <AuthProvider>
          <Layout>
            <Support />
          </Layout>
          </AuthProvider>
        )
      },
      {
        path: '/calendar',
        element: (
          <AuthProvider>
          <Layout>
            <Calendar />
          </Layout>
          </AuthProvider>
        )
      },
      {
        path: '/statistics',
        element: (
          <AuthProvider>
          <Layout>
            <Statistics />
          </Layout>
          </AuthProvider>
        )
      },
      {
        path: '/not-activated',
        element: (
          <AuthProvider>
           <NotActivated />
          </AuthProvider>
        )
      },
    ]
  },
];

export default router;